import { render, staticRenderFns } from "./cBrandedContent.vue?vue&type=template&id=be4b8520&scoped=true"
import script from "./cBrandedContent.vue?vue&type=script&lang=js"
export * from "./cBrandedContent.vue?vue&type=script&lang=js"
import style0 from "./cBrandedContent.vue?vue&type=style&index=0&id=be4b8520&prod&scoped=true&lang=css"
import style1 from "./cBrandedContent.vue?vue&type=style&index=1&id=be4b8520&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4b8520",
  null
  
)

export default component.exports